import React, { useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { Navigate } from "react-router-dom";
import { AppConfig } from "../config/appConfig";

const Login = () => {
  const { authenticated } = useContext(UserContext);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenInUrl = urlParams.get("token");

    console.log("Login: comprobando redirección. Autenticado:", authenticated, "Token en URL:", !!tokenInUrl);

    // Si ya estamos autenticados o hay un token llegando en la URL, no hacemos nada.
    // Dejamos que UserContext procese el token o que el render nos lleve al Home.
    if (authenticated || tokenInUrl) {
      console.log("Login: Usuario autenticado o token en URL. Abortando redirección al SSO.");
      return;
    }

    // Redirigir al sistema de login único externo solo si estamos seguros de que no hay sesión
    const publicUrl = process.env.PUBLIC_URL === "." ? "" : (process.env.PUBLIC_URL || "");
    const baseUrl = window.location.origin + publicUrl;
    const returnUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
    const loginUrl = `${AppConfig.LOGIN_URL_BASE}?applicationId=${AppConfig.LOGIN_APP_ID}&returnUrl=${encodeURIComponent(returnUrl)}`;

    const timer = setTimeout(() => {
      // Doble verificación: si en este segundo apareció un token o nos autenticamos, abortar.
      const currentParams = new URLSearchParams(window.location.search);
      if (!authenticated && !currentParams.get("token")) {
        window.location.href = loginUrl;
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [authenticated]);

  // Si ya estamos autenticados, vamos directo al home
  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      gap: '20px'
    }}>
      <img src="/logo_chico_produce.png" alt="Logo" style={{ width: '200px' }} />
      <p>Redirigiendo al sistema de autenticación...</p>
      <div className="spinner"></div>
    </div>
  );
};

export default Login;
